// CardSubCarousel.js
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./CardSubCarousel.css";

/*
const subCards = {
  1: [
    { order: 1, title: "考試", 
      description: ["不顯示題組內狀態", "不顯示結果統計", "預設初始顯示所有題目", "預設無獎勵"] 
    },
    { order: 2, title: "趣味問答", 
      description: ["顯示題組內狀態", "顯示結果統計", "預設初始顯示所有題目", "預設有獎勵"] 
    },
  ],
  2: [{ order: 1, title: "調查", subtitle: "（有標準答案）", color: "#f9c74f" }],
  3: [{ order: 1, title: "解說", subtitle: "（無標準答案）", color: "#577590" }],
  4: [{ order: 1, title: "廣告", subtitle: "（有標準答案）", color: "#90be6d" }],
};
*/

const CardSubCarousel = ({ subCards, activeIndex=0, setActiveIndex, activeSubIndex=0, setActiveSubIndex }) => {

  const goLeft = () => setActiveSubIndex((prev) => Math.max(prev - 1, 0));
  const goRight = () => setActiveSubIndex((prev) => Math.min(prev + 1, subCards.length - 1));

  const handlers = useSwipeable({
    onSwipedLeft: () => goRight(),
    onSwipedRight: () => goLeft(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // allow swipe with mouse for testing
  });

  const getTranslateX = (index) => {
    if (index === 0) return "calc(50% - 40vw)"; // first card offset
    if (index === subCards.length - 1) return `calc(50% - ${(index * 63.5 + 42)}vw + 10vw)`; // adjust for last card
    return `calc(50% - ${index * 63.5 + 31}vw)`; // default
  };

  return (
    <div className="carousel-sub-container">
      <div className="carousel-sub-cards-wrapper" {...handlers}>
        <div
          className="carousel-sub-cards-inner"
          style={{
            transform: `translateX(${getTranslateX(activeSubIndex)})`,
          }}
        >
          {subCards.map((card, idx) => {
            if (card.isPlaceholder) {
              return (
                <div
                  key={`placeholder-${idx}`}
                  className="carousel-sub-card placeholder-card"
                  style={{
                    backgroundColor: "white",
                    border: `3px dashed ${card.color}`,
                    fontSize: "16px",
                    color: "black",
                    cursor: "default"
                  }}
                >
                </div>
              );
            }

            // Normal card rendering
            return (
              <div
                key={card.id}
                className={
                  `d-flex flex-column align-items-center 
                  carousel-sub-card carousel-sub-card-${activeIndex + 1} 
                  ${idx === activeSubIndex ? "active" : ""}`
                }
                style={{ 
                  border: `3px solid ${card.color}`,
                  backgroundColor: `${card.color}`,
                  fontSize: "16px",
                  paddingTop: "14px",
                  color: activeIndex===0 ? "#233544" : "white",
                  cursor: "pointer"
                }}
                onClick={() => setActiveSubIndex(card.order - 1)}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "20%",
                  width: "90%"
                }}>
                  <p className="mb-0">{card.title}</p>
                </div>
                <div className="sub-card-description" style={{
                  display: "flex",
                  alignItems: "flex-start",
                  padding: "10px 0px 0px 10px",
                  flexDirection: "column",
                  height: "80%",
                  width: "90%",
                  zIndex: "10"
                }}>
                  <ul style={{ paddingLeft: "0px", marginBottom: 0 }}>
                    {card.description.map((desc, idx) => (
                      <li
                        key={`description-${idx}`}
                        style={{
                          color: "black",
                          marginBottom: "4px",
                          listStyleType: "none",
                          position: "relative",
                          paddingLeft: "16px",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "9px",
                            width: "6px",
                            height: "6px",
                            backgroundColor: "#333",
                            borderRadius: "50%", // Circle bullet
                            content: '""'
                          }}
                        />
                        {desc}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="carousel-sub-pagination-dots">
        {subCards.map((_, idx) => (
          <span
            key={idx}
            className={`carousel-sub-dot ${idx === activeSubIndex ? "active" : ""}`}
            onClick={() => setActiveSubIndex(idx)}
          />
        ))}
      </div>

      <div className="carousel-sub-nav-buttons">
        <button onClick={goLeft} disabled={activeSubIndex === 0}>‹</button>
        <button onClick={goRight} disabled={activeSubIndex === subCards.length - 1}>›</button>
      </div>
    </div>
  );
};

export default CardSubCarousel;
